/**
 * Returns the API client and endpoint set for pricebook operations.
 * Always uses the operations microservice.
 */
import { operationsClient } from '@/lib/api';
import { operationsPricebookEndpoints } from '@/lib/api/endpoints';

export type PricebookApiEndpoints = typeof operationsPricebookEndpoints;

export interface PricebookApi {
  client: typeof operationsClient;
  ep: PricebookApiEndpoints;
}

export function usePricebookApi(): PricebookApi {
  return { client: operationsClient, ep: operationsPricebookEndpoints };
}
